import type { MutableRefObject } from "react";
import { useState, useRef } from "react";

type TooltipHookReturnType = {
  buttonRef: MutableRefObject<HTMLButtonElement | null>;
  tooltipRef: MutableRefObject<HTMLDivElement | null>;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
  showTooltip: boolean;
  tooltipPosition: { left: number; top: number };
};

export const useTooltip = (): TooltipHookReturnType => {
  const [showTooltip, setShowTooltip] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const calculateTooltipPosition = () => {
    if (buttonRef.current && tooltipRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();

      const left =
        buttonRect.left - (tooltipRect.width / 2 - buttonRect.width) / 2;
      const top = buttonRect.bottom;

      return { left, top };
    }
    return { left: 792, top: 850 };
  };

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const tooltipPosition = calculateTooltipPosition();

  return {
    buttonRef,
    tooltipRef,
    handleMouseEnter,
    handleMouseLeave,
    showTooltip,
    tooltipPosition
  };
};
